/*
 * @providesModule ScreenNames
 *
 */

enum ScreenNames {
  ENTRY_SCREEN = 'home',
  STAKES_SELECTION = 'stakes-selection',
  SEARCHING_SCREEN = 'searching-screen',
  FRIEND_REFERRAL = 'friend-referral',
  RESULT = 'result',
  LEVELS = 'levels',
  TROPHIES = 'trophies',
  TICKETZ = 'ticketz-home',
  TICKETZ_ABOUT = 'ticketz-about',
  TICKETZ_ITEM_DETAIL = 'ticketz-item-detail',
  TICKETZ_ORDER_SUMMARY = 'ticketz-order-summary',
  TICKETZ_CATEGORY_LIST = 'ticketz-category-list',
  TICKETZ_EDIT_ADDRESS = 'ticketz-edit-address',
  ACCOUNT = 'account-home',
  ACCOUNT_BALANCE = 'account-balance',
  ACCOUNT_MERGE = 'account-merge',
  ACCOUNT_PASSWORD = 'account-password',
  ACCOUNT_PERSONAL = 'account-personal-info',
  ACCOUNT_EMAIL_EDIT = 'account-personal-info-email-edit',
  ACCOUNT_EMAIL_MANAGEMENT = 'account-email-management',
  ACCOUNT_ADDRESS = 'account-personal-info-address',
  ACCOUNT_PHONE = 'account-phone',
  ACCOUNT_USERNAME = 'account-username',
  ACCOUNT_WITHDRAW = 'account-withdraw',
  LIVE_EVENT = 'live-event',
  PRIZE_DETAILS = 'prize-details',
  BRACKET_RESULTS = 'brackets-results',
  BRACKETS_V2 = 'brackets-v2',
  BRACKET_VERSUS = 'bracket-versus',
  VERSUS_COORDINATOR = 'versus',
  PLAYER_PROFILE = 'player-profile',
  SKILLZ_REWARDS = 'skillz-rewards',
  SKILLZ_REWARDS_INFO = 'skillz-rewards-info',
  EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
  OTP_INPUT_FIELD = 'OTP_INPUT_FIELD',
  DAILY_BONUS_CASH_SCREEN = 'DAILY_BONUS_CASH_SCREEN',
}

export default ScreenNames;
